import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaChevronDown } from 'react-icons/fa';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      pergunta: 'Quanto custa para criar um site?',
      resposta: 'O valor varia conforme a complexidade e funcionalidades do projeto. Sites institucionais simples têm um investimento diferente de sistemas personalizados. Entre em contato para receber um orçamento personalizado sem compromisso.',
    },
    {
      pergunta: 'Quanto tempo leva para desenvolver um site?',
      resposta: 'O prazo depende do tipo e tamanho do projeto. Um site institucional simples pode ficar pronto em 2-3 semanas, enquanto sistemas mais complexos podem levar de 4 a 8 semanas. Sempre definimos prazos realistas e te mantemos informado em cada etapa.',
    },
    {
      pergunta: 'O site será responsivo (funciona em celular)?',
      resposta: 'Sim! Todos os sites que desenvolvo são totalmente responsivos e funcionam perfeitamente em smartphones, tablets e desktops.',
    },
    {
      pergunta: 'Você faz manutenção após a entrega?',
      resposta: 'Sim, ofereço pacotes de manutenção mensal para atualizações de conteúdo, correções, backups e melhorias.',
    },
    {
      pergunta: 'Como funciona o processo de pagamento?',
      resposta: 'Trabalho com pagamento parcelado: uma entrada para iniciar o projeto e o restante dividido em parcelas durante o desenvolvimento. Aceito PIX, transferência bancária e cartão de crédito.',
    },
    {
      pergunta: 'O site aparece no Google?',
      resposta: 'Sim, desenvolvo sites otimizados para SEO, o que ajuda no posicionamento no Google.',
    },
    {
      pergunta: 'Você trabalha com sistemas personalizados?',
      resposta: 'Sim! Desenvolvo sistemas sob medida para automatizar processos do seu negócio, como gestão de clientes, agendamentos, relatórios e muito mais.',
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-32 bg-cream dark:bg-dark-bg transition-colors duration-500">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 gsap-reveal">
          <p className="text-burnt font-heading font-semibold uppercase tracking-wider text-sm mb-4">FAQ</p>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-dark dark:text-cream mb-4">
            Perguntas Frequentes
          </h2>
          <p className="text-xl text-dark/70 dark:text-cream/70 max-w-2xl mx-auto font-body">
            Tire suas dúvidas sobre desenvolvimento de sites e sistemas
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="gsap-reveal rounded-2xl bg-white dark:bg-dark-surface border border-brown/10 dark:border-burnt/10 overflow-hidden transition-all duration-300 hover:border-burnt/30"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none focus:ring-2 focus:ring-burnt/30 focus:ring-inset"
                aria-expanded={openIndex === index}
                data-cursor="pointer"
              >
                <span className="text-lg font-heading font-semibold text-dark dark:text-cream pr-4">
                  {faq.pergunta}
                </span>
                <motion.span
                  animate={{ rotate: openIndex === index ? 180 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="text-burnt flex-shrink-0"
                >
                  <FaChevronDown className="text-xl" />
                </motion.span>
              </button>
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <div className="px-6 pb-5">
                      <p className="text-dark/80 dark:text-cream/80 leading-relaxed font-body">
                        {faq.resposta}
                      </p>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center gsap-reveal">
          <p className="text-dark/70 dark:text-cream/70 mb-6 font-body">
            Não encontrou a resposta que procurava?
          </p>
          <a
            href="#contato"
            className="btn-premium inline-block bg-burnt hover:bg-primary-700 text-white px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-300 transform hover:scale-105 shadow-premium"
            data-cursor="pointer"
          >
            Entre em Contato
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
